import Api from '@/axios'

export default {
  updateinstructor (instructorId, payload, status) {
    return Api().post(`instructors-status/${instructorId}?status=${status}`, payload)
  }
}
